{
  "shared": {
    "chart": {
      "showTable": "Show as table",
      "hideTable": "Hide table",
      "asOf": "As of {{time}}",
      "unavailable": "These figures are not available for your access.",
      "noRows": "No figures to show.",
      "toDate": "to date",
      "monthColumn": "Month",
      "tooFewMonths": "Too few months with activity to draw a trend: {{active}} of {{total}}. Each month with activity:",
      "latest": "Latest",
      "highest": "Highest",
      "inspectMonths": "Inspect months",
      "inspect": "Inspect {{label}}",
      "pointValues": "{{month}}: {{values}}",
      "meter": {
        "used": "{{percent}} used",
        "committed": "Committed",
        "reserved": "Reserved",
        "available": "Available",
        "ofAllocated": "of {{allocated}} allocated",
        "threshold": "Warning at {{percent}}",
        "health": {
          "within": "Within its allocation",
          "warning": "Near its limit",
          "exceeded": "Over its allocation",
          "frozen": "Frozen"
        }
      }
    }
  }
}
